import { Component, Input, OnInit } from '@angular/core';
import { JsFndaUser } from '../../models/layout-model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { LayoutService } from 'src/app/shared/auth/layout-service';

@Component({
  selector: 'app-switch-dialog',
  templateUrl: './switch-dialog.component.html',
  styleUrls: ['./switch-dialog.component.scss']
})
export class SwitchDialogComponent {
  @Input() onSelectData: (data: any) => void;
  userData: JsFndaUser[];
  searchKeyword = '';
  selectedUser: JsFndaUser;
  isLoading = false;
  maxItemDisplay = '';

  constructor(
    private envServ: EnvironmentconfigService,
    public nzMsgSer: NzMessageService,
    private translate: TranslateService,
    private webApiServ: WebApiService,
    public layoutServ: LayoutService
  ) { }


  // 模拟选择数据的方法
  selectData(data: any) {
    this.selectedUser = data;
    if (this.onSelectData) {
      this.onSelectData(data);
    }
  }

  // 获取选择的数据
  getSelectedData() {
    return this.selectedUser;
  }

  searchUsers() {
    if (this.searchKeyword && this.searchKeyword.length >= 3) {
      this.isLoading = true;
      const url = `${this.envServ.authConfig.MVMBackEnd}${URLConst.GetUserList.url}` + this.searchKeyword;
      this.webApiServ.doGet(url).subscribe((res) => {
        this.isLoading = false;
        if (res.rc == 0) {
          //防止資料太多畫面卡住，限制最多顯示100筆
          if (res.data.length > 100) {
            this.userData = res.data.slice(0, 100);
            this.maxItemDisplay = this.translate.instant('MaxItemDisplay').replace('{maxCount}', '100');
          } else {
            this.userData = res.data;
            this.maxItemDisplay = '';
          }
        } else {
          this.nzMsgSer.error(res.msg);
        }
      });
    } else {
      this.nzMsgSer.warning(this.translate.instant('inputvalue'));
    }
  }
}
